import React from 'react';
import { cn } from '../../lib/utils';

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'secondary' | 'destructive' | 'outline' | 'success' | 'warning';
}

function Badge({ className, variant = 'default', ...props }: BadgeProps) {
  return (
    <div
      className={cn(
        'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400 focus:ring-offset-2',
        {
          'border-transparent bg-blue-600 text-white shadow hover:bg-blue-700 dark:bg-blue-600 dark:hover:bg-blue-700': variant === 'default',
          'border-transparent bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-gray-100 hover:bg-gray-200 dark:hover:bg-gray-600': variant === 'secondary',
          'border-transparent bg-red-600 text-white shadow hover:bg-red-700 dark:bg-red-600 dark:hover:bg-red-700': variant === 'destructive',
          'text-gray-950 dark:text-gray-50 border-gray-300 dark:border-gray-600': variant === 'outline',
          'border-transparent bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300': variant === 'success',
          'border-transparent bg-yellow-100 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-300': variant === 'warning',
        },
        className
      )}
      {...props}
    />
  );
}

export { Badge };